import { FeatureFlags } from '../pages/Home/HomeSlice';

export enum Feature {
  EDIT = 'edit',
  TAX_EXEMPT = 'taxExempt',
  MAINTENANCE = 'sorryPage'
}

export function isFeatureEnabled (featureState: FeatureFlags, feature: string | string[]): boolean {
  if (Array.isArray(feature)) {
    return feature.every(f => !!featureState[f]);
  }
  return !!featureState[feature];
}